import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axios from 'axios'
import { Link } from "react-router-dom";
import { createPractitionerProfile, getPractitionerProfiles, getUserProfile } from "../../features/practitionerProfiles/practitionerProfileSlice"
import { updateUser } from "../../features/auth/authSlice";
import { useDispatch } from "react-redux"
import pen from "../../img/Edit.png";
import AMEX from "../../img/american-express.png"
import VISA from "../../img/visa.png"
import DISCOVER from "../../img/discover-card.png"
import MASTERCARD from "../../img/mastercard.png"
import calendarIcon from "../../img/appointment.png"
import "../../styles/PractitionerProfileStyles.css";
import "../../styles/adminEdit.css"
import "../../styles/index.css";
import MultiSelect from 'react-multiple-select-dropdown-lite'
import { NewFooter } from "../../components/newFooter";
import { getPractitionerUsers, updateUserAdmin} from "../../features/auth/authSlice";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBFile,
} from "mdb-react-ui-kit";

const AdminEditPractitioners = () => {
  const { user, practitionerUsers } = useSelector((state) => state.auth)
  const { profile } = useSelector((state) => state.practitionerProfiles)
  const [editPractitioner, setEditPractitioner] = useState({})
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalCalendly, setBasicModalCalendly] = useState(false);
  const [basicModalLast, setBasicModalLast] = useState(false);
  const [basicModaltwo, setBasicModaltwo] = useState(false);
  const [basicModalpayment, setBasicModalpayment] = useState(false);
  // const [firstProfile, setFirstProfile] = useState({ firstName: editPractitioner?.firstName, lastName: editPractitioner?.lastName, practiceName: editPractitioner?.practiceName, practicePhoneNumber: editPractitioner?.practicePhoneNumber, specialty: editPractitioner?.specialty, subSpecialty: editPractitioner?.subSpecialty, location: editPractitioner?.location, credentials: editPractitioner?.credentials, appointmentType: editPractitioner?.appointmentType, practiceAddress: editPractitioner?.practiceAddress, calendlyUrl: editPractitioner?.calendlyUrl });
  const [secondProfile, setSecondProfile] = useState({ aboutMe: '', howCanIHelp: '', yearsOfExperience: '', education: '', servicesOffered: '', cancellationPolicy: '' });
  const [showbuttons, setShowButtons] = useState(false);
  const [showbuttonstwo, setShowButtonsTwo] = useState(false);
  const [showbuttonsthree, setShowButtonsThree] = useState(false);
  const [showbuttonsfour, setShowButtonsFour] = useState(false);
  const [file, setFile] = useState(null)


  // REDUX DISPATCH AND REACT PAGE CHANGE
  const dispatch = useDispatch()
  const navigate = useNavigate()


  const toggleShow = () => setBasicModal(!basicModal);
  const toggleShowtwo = () => setBasicModaltwo(!basicModaltwo);
  const toggleShowlast = () => setBasicModalLast(!basicModalLast);
  const toggleShowpayment = () => setBasicModalpayment(!basicModalpayment);
  const toggleShowCalendly = () => setBasicModalCalendly(!basicModalCalendly);

  // USE EFFECTS FOR UPDATING INFORMATION
  useEffect(() => {
    if (!user) {
      navigate('/practitionerLogin')
    }
    if (!user?.profile) {
      dispatch(createPractitionerProfile({ created: true }));
      dispatch(getPractitionerProfiles());
    }

  }, [])

  useEffect(() => {
    if (user?.profile) {
      dispatch(getPractitionerProfiles())
      dispatch(getUserProfile(user?.profile))
    }
  }, [user])

  useEffect(() => {
    setSecondProfile({ ...secondProfile, ...profile })
  }, [profile])



  // STATIC INFORMATION
  const practitionerTypes = [
    "Gyno-urology",
    "Nurse Practitioner (ARNP)",
    "Nutritionist",
    "OBGYN",
    "Occupational Therapist (OT)",
    "Pain Management Doctor",
    "Pain Management Psychologist",
    "Pelvic Health Physical Therapist",
    "Physical Therapist Assistant (PTA)",
    "Physician (MD)",
    "Pilates Instructor",
    "Sex Coach / Therapist",
    "Women's Health Coach",
    "Women's Health Psychologist",
    "Women's Mental Health Therapist",
    "Yoga Instructor",
  ];

  const options = [
    { label: 'Bladder & Bowel Incontinence', value: 'Bladder & Bowel Incontinence' },
    { label: 'Bladder Pain', value: 'Bladder Pain' },
    { label: 'Constipation', value: 'Constipation' },
    { label: 'Endometriosis', value: 'Endometriosis' },
    { label: 'Menopause & Perimenopause', value: 'Menopause & Perimenopause' },
    { label: 'Painful Sex', value: 'Painful Sex' },
    { label: 'Pelvic Organ Prolapse', value: 'Pelvic Organ Prolapse' },
    { label: 'Postpartum Recovery', value: 'Postpartum Recovery' },
    { label: 'Proactive Pelvic Care', value: 'Proactive Pelvic Care' },
    { label: 'Separated Abs', value: 'Separated Abs' },
    { label: 'Vaginoplasty Prep and Recovery', value: 'Vaginoplasty Prep and Recovery' },
  ]

  // HANDLE USER CHANGES
  const handleFirstChange = e => {
    setEditPractitioner({ ...editPractitioner, [e.target.name]: e.target.value });
    console.log(editPractitioner);
  };

  // HANDLE PROFILE CHANGES
  const handleSecondChange = e => {
    const propertyName = e.target.name

    if (propertyName === 'certifications') {
      const found = secondProfile.certifications.find(item => item === e.target.value)
      console.log(found)
      if (found) {
        const filter = secondProfile.certifications.filter(item => item !== e.target.value)
        setSecondProfile((prevProfile) => ({ ...prevProfile, certifications: filter }))
      }
      else {
        setSecondProfile((prevProfile) => ({ ...prevProfile, certifications: [...prevProfile.certifications, e.target.value] }));
      }
    } else if (propertyName === 'availability') {
      const found = secondProfile.availability.find(item => item === e.target.value)
      console.log(found)
      if (found) {
        const filter = secondProfile.availability.filter(item => item !== e.target.value)
        setSecondProfile((prevProfile) => ({ ...prevProfile, availability: filter }))
      }
      else {
        setSecondProfile((prevProfile) => ({ ...prevProfile, availability: [...prevProfile.availability, e.target.value] }));
      }
    } else if (propertyName === 'paymentMethods') {
      const found = secondProfile.paymentMethods.find(item => item === e.target.value)
      console.log(found)
      if (found) {
        const filter = secondProfile.paymentMethods.filter(item => item !== e.target.value)
        setSecondProfile((prevProfile) => ({ ...prevProfile, paymentMethods: filter }))
      }
      else {
        setSecondProfile((prevProfile) => ({ ...prevProfile, paymentMethods: [...prevProfile.paymentMethods, e.target.value] }));
      }
    } else {
      setSecondProfile((prevProfile) => ({ ...prevProfile, [e.target.name]: e.target.value }));
    }
  };

  // HANDLE APPOINTMENT TYPE CHANGE FOR USER
  const handleCheckBoxChange = (appointmentType) => {
    if (appointmentType === "virtual") {
      setEditPractitioner({ ...editPractitioner, appointmentType: { virtual: true, inPerson: false } })
    }
    if (appointmentType === "inPerson") {
      setEditPractitioner({ ...editPractitioner, appointmentType: { virtual: false, inPerson: true } })
    }
    if (appointmentType === "both") {
      setEditPractitioner({ ...editPractitioner, appointmentType: { virtual: true, inPerson: true } })
    }
    console.log("appointmentType", appointmentType)
  }

  // HANDLE SUBSPECIALTY CHANGES
  const handleSubSpecialty = val => {
    const myArray = val.split(",")
    setEditPractitioner((prevState) => ({
      ...prevState,
      subSpecialty: myArray,
    }));
  }

  // HANDLING IMAGE UPLOADS
  const handleFile = (e) => {
    console.log(e.target.files)
    setFile(e.target.files)
  }
  const handleSubmitFile = (e) => {
    console.log(e)
    e.preventDefault();
    console.log('sumbittting')
    const formImage = new FormData(e.target);
    formImage.append("file", file);
    for (let key of formImage.keys()) {
      console.log(key, formImage.get(key));
    }
    const token = localStorage.getItem("token")
    console.log(token)
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
    axios.put(`https://elana-api.herokuapp.com/api/practitionerProfiles/${profile._id}/upload`, formImage, config,)
      .then(res => {
        if (res.data) {
          dispatch(getUserProfile(profile._id))
        }
      })
      .catch(err => console.log(err))
  };

  // HANDLING PROFILE UPDATE
  const handleUpdateProfile = (data) => {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`

      }
    }
    axios.put(`https://elana-api.herokuapp.com/api/practitionerProfiles/${profile._id}`, data, config)
      .then(res => {
        if (res.data) {
          dispatch(getUserProfile(profile._id))
        }
      })
      .catch(err => console.log(err))
  }

  const adminUpdateUser = async (updatedUserData, userId) => {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    await axios
      .put(`https://elana-api.herokuapp.com/api/practitionerUsers/admin/${userId}`, updatedUserData, config)
      .then((res) => {
        if (res.data) {
          dispatch(getPractitionerUsers());
        }
      })
      .catch((err) => console.log(err));
  };



  console.log("Second Profile: ", secondProfile)

  // here is another idea of how to limit the characters in the input field
 
  // const handleNameChange = event => {
  //   const limit = 5;

  //   // 👇️ only take first N characters
  //   setFirstName(event.target.value.slice(0, limit));
  // };

  useEffect(() => {
    if(practitionerUsers.length == 0){
    dispatch(getPractitionerUsers())
    dispatch(getPractitionerProfiles())
  }
  }, [])

  const params = useParams();

  const getPractitionerData = () =>{
    let editingPerson = practitionerUsers.find((item)=>{
      if(item._id === params.editPersonId ){
        return item
      }
    })
    return editingPerson
  }

  useEffect(()=>{
    setEditPractitioner(getPractitionerData())
  },[practitionerUsers])

  // useEffect(()=>{
  //   setDisplaySubSpecialty(stringSubSpecialties())
  // },[editPractitioner])



  const stringSubSpecialties = () => {
    let string = editPractitioner?.subSpecialty.map((item, index, arr) => {
      if (index === arr.length - 1) {
        return (`${item}`)
      } else {
        return (`${item}, `)
      }
    })
    return string
  }
    
  

console.log('Practitioner', editPractitioner)

  return (
    <div>
     <div>
      <MDBContainer className="container-profile">
        <div className="container">
          <h1 className="mb-5 ms-3 text-start text-al mt-5 fs-40-32">You are editing:: {editPractitioner?.firstName && `Dr. ${editPractitioner?.firstName} ${editPractitioner?.lastName}`}</h1>
        </div>
        <MDBRow>
          <MDBCol className="mb-5 d-flex justify-content-center">
            <div className="first-section-profile-admin ">
              <div className="">
                <div className="selection">
                  <div className={!profile?.image ? "photo-secction-border" : "photo-secction"}>
                    {!profile?.image && <img
                      alt="edit"
                      src={pen}
                      onClick={toggleShow}
                      className="pe-3 pt-2 fa-pen pointer" />}
                    <div className="center-p mt-2">
                      <div className="overlay border-none">
                        {profile?.image ? <img src={profile?.image} onClick={toggleShow} className="pointer img-fluid image-profile-edit" alt="profile" /> : <p className="coming-soon-text">Upload <br /> Photo </p>}
                      </div>
                    </div>
                  </div>


                  <MDBModal show={basicModal} setShow={setBasicModal} tabIndex="-1">
                    <MDBModalDialog className="boxmodal modal-lg">
                      <MDBModalContent className="bgmodal">
                        <MDBModalHeader>
                          <MDBModalTitle>Upload Photo</MDBModalTitle>
                          <MDBBtn
                            className="btn-close"
                            color="none"
                            onClick={toggleShow}
                          ></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody className="resmodal">
                          <p className="text-center">
                            Please include a photograph
                          </p>
                          <div className="mt-2 bg-responsive">
                            <MDBCol className="" sm="">
                              <div>
                                <form onSubmit={handleSubmitFile}>
                                  <MDBFile name="file" onChange={handleFile} />
                                  <br />
                                  {/* {previewSource && (
                                    <img src={previewSource} alt="choosen" style={{ height: "200px" }}></img>
                                  )} */}
                                  {/* <MDBBtn className="buttonmainpage blue-hover border-0 me-5 mb-5  px-5 buttonmodalresponsive text-dm" type="submit">
                                    Save
                                  </MDBBtn> */}
                                  <button className="btn main-purple-button blue-hover text-dm" onClick={toggleShow}type="submit">
                                    Save
                                  </button>
                                </form>
                              </div>
                            </MDBCol>
                          </div>
                        </MDBModalBody>


                      </MDBModalContent>
                    </MDBModalDialog>
                  </MDBModal>
                </div>
              </div>


              <div>
                <div className="name-profile ms-4">
                  <h3 className="text-al fs-22-18">Practice Name</h3>
                  <img
                    alt=""
                    src={pen}
                    className="pen2 pointer"
                    onClick={toggleShowtwo}
                  ></img>
                  <MDBModal
                    show={basicModaltwo}
                    setShow={setBasicModaltwo}
                    tabIndex="-1"
                  >
                    <MDBModalDialog className="boxmodal modal-lg boxmodalresponsive">
                      <MDBModalContent className="bgmodal">
                        <MDBModalHeader>
                          <MDBModalTitle>Edit Credentials</MDBModalTitle>
                          <MDBBtn
                            className="btn-close"
                            color="none"
                            onClick={toggleShowtwo}
                          ></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                          <div className="margin-left">
                            <div className="m-1 div-grid">
                              <div className="col-sm ">
                                <label className="labelsingup text-muted">
                                  First Name
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb input-size"
                                  id="form1"
                                  name="firstName"
                                  value={editPractitioner?.firstName}
                                  onChange={handleFirstChange}
                                />
                              </div>

                              <div className="col-sm labelresponsive-right">
                                <label className="labelsingup text-muted whitespace">
                                  Last Name
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  name="lastName"
                                  value={editPractitioner?.lastName}
                                  onChange={handleFirstChange}
                                />
                              </div>
                            </div>
                            <div className="div-grid m-1">
                              <div className="col-sm ">
                                <label className="labelsingup text-muted">
                                  Practice Name
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  name="practiceName"
                                  value={editPractitioner?.practiceName}
                                  onChange={handleFirstChange}
                                />
                              </div>

                              <div className="col-sm labelresponsive-right">
                                <label className="labelsingup text-muted whitespace">
                                  Practice Phone Number
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  name="practicePhoneNumber"
                                  value={editPractitioner?.practicePhoneNumber}
                                  onChange={handleFirstChange}
                                />
                              </div>
                            </div>

                            <div className="div-grid m-1">
                              <div className="col-sm ">
                                <label className="labelsingup text-muted">
                                  Education
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  name="education"
                                  value={secondProfile.education}
                                  onChange={handleSecondChange}
                                />
                              </div>

                              <div className="col-sm labelresponsive-right">
                                <label className="labelsingup text-muted whitespace">
                                  Years Of Experience
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  name="yearsOfExperience"
                                  value={secondProfile.yearsOfExperience}
                                  onChange={handleSecondChange}
                                />
                              </div>
                            </div>

                            <div className="div-grid">
                              <div className="dropdown responsive-margin-drop">
                                <label className="labelsingup text-muted whitespace">
                                  Specialty
                                </label>
                                <button className="btn btn-light dropdown-toggle mdb input-size"
                                  type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                  {editPractitioner?.specialty}
                                </button>
                                <ul className="dropdown-menu ul-overflow" aria-labelledby="dropdownMenuButton1" >
                                  {practitionerTypes.map((type, index) => {
                                    return <li key={index} className="text-muted li-hover p-1 " onClick={() => setEditPractitioner({ ...editPractitioner, specialty: type })}  >
                                      {editPractitioner?.specialty === type && <i className="fas fa-check me-2"></i>}
                                      {type}
                                    </li>
                                  })}
                                </ul>
                              </div>
                              {/* <div className=" ">
                                <label className="labelsingup text-muted whitespace">
                                  Specialty
                                </label>
                                <select
                                  style={{ width: "200px", margin: "0px" }}
                                  className="form-select select-class"
                                  id="inputGroupSelect04"
                                  aria-label="Example select with button addon"
                                  name="specialty"
                                  value={editPractitioner.specialty}
                                  onChange={handleFirstChange}
                                  required
                                >
                                  <option value="0" className="text-muted">
                                    -select one-
                                  </option>
                                  {practitionerTypes.map((type, index) => {
                                    return <option key={index} value={type} className="text-muted">
                                      {type}
                                    </option>
                                  })}
                                </select>
                              </div> */}

                              <div className="labelresponsive-right-special ">
                                <div className="try margin-responsive-mmultiSelect">
                                  <label className="labelsingup text-muted">Sub-Specialty</label>
                                  <div className="multiselect col-sm col-md-12">
                                    <div>
                                      <MultiSelect
                                        // className="multiselect"
                                        style={{
                                          width: "210px",
                                          background: "white",
                                          // minWidth: '242px',
                                          // minWidth: '520px',
                                          // marginLeft: '15px',
                                          marginRight: "20px"
                                          // fontFamily: 'Karla'
                                        }}

                                        // name="subSpecialty"
                                        value={editPractitioner?.subSpecialty}
                                        onChange={handleSubSpecialty}
                                        options={options}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="div-grid m-1">
                              <div className="col-sm ">
                                <label className="labelsingup text-muted whitespace">
                                  Credentials
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  name="credentials"
                                  value={editPractitioner?.credentials}
                                  onChange={handleFirstChange}
                                />
                              </div>

                              <div className="col-sm labelresponsive-right">
                                <label className="labelsingup text-muted whitespace">
                                  Location
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  name="location"
                                  value={editPractitioner?.location}
                                  onChange={handleFirstChange}
                                />
                              </div>
                            </div>

                            <div className="div-grid m-1">
                              <div className="col-sm ">
                                <label className="labelsingup text-muted">
                                  Instagram <span className="text-dm">(your page)</span>
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  value={secondProfile.instagramUrl}
                                  name='instagramUrl'
                                  onChange={handleSecondChange}
                                />
                              </div>

                              <div className="col-sm labelresponsive-right">
                                <label className="labelsingup text-muted whitespace">
                                  Facebook <span className="text-dm">(your page)</span>
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  value={secondProfile.facebookUrl}
                                  name='facebookUrl'
                                  onChange={handleSecondChange}
                                />
                              </div>
                            </div>

                            <div className="div-grid m-1">
                              <div className="col-sm ">
                                <label className="labelsingup text-muted">
                                  Linkedin <span className="text-dm">(your page)</span>
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  value={secondProfile.linkedinUrl}
                                  name='linkedinUrl'
                                  onChange={handleSecondChange}
                                />
                              </div>

                              <div className="col-sm labelresponsive-right ">
                                <label className="labelsingup text-muted whitespace">
                                  Practice Address
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  name="practiceAddress"
                                  value={editPractitioner?.practiceAddress}
                                  onChange={handleFirstChange}
                                />
                              </div>
                            </div>

                            <div className="div-grid m-1">
                              <div className="col-sm">
                                <label className="labelsingup text-muted">
                                  Calendly Url
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  name="calendlyUrl"
                                  value={editPractitioner?.calendlyUrl}
                                  onChange={handleFirstChange}
                                />
                              </div>

                              <div className="col-sm labelresponsive-right d-none">
                                <label className="labelsingup text-muted whitespace">
                                  test
                                </label>
                                <MDBInput
                                  type="text"
                                  className="form-control mdb  input-size"
                                  id="form1"
                                  name="practicePhoneNumber"
                                  value={editPractitioner?.practicePhoneNumber}
                                  onChange={handleFirstChange}
                                />
                              </div>
                            </div>

                            <p className="">What type of services do you provide?</p>
                            <div className="d-flex ">
                              <div className="">
                                <label>Virtual</label>
                                <input type="checkbox" className="checkbox-squer m-2" onChange={() => handleCheckBoxChange("virtual")} checked={editPractitioner?.appointmentType?.virtual && editPractitioner?.appointmentType?.inPerson === false}></input>
                              </div>
                              <div>
                                <label>In person</label>
                                <input type="checkbox" className="checkbox-squer m-2" onChange={() => handleCheckBoxChange("inPerson")} checked={editPractitioner?.appointmentType?.virtual === false && editPractitioner?.appointmentType?.inPerson === true}></input>
                              </div>
                              <div>
                                <label>Both</label>
                                <input type="checkbox" className="checkbox-squer m-2" onChange={() => handleCheckBoxChange("both")} checked={editPractitioner?.appointmentType?.virtual && editPractitioner?.appointmentType?.inPerson} ></input>
                              </div>
                            </div>
                          </div>
                        </MDBModalBody>

                        <MDBModalFooter>
                          <button className="btn main-purple-button blue-hover text-dm"

                            onClick={() => {
                              toggleShowtwo()
                              adminUpdateUser(editPractitioner, params.editPersonId)
                              // handleUpdateProfile(secondProfile)
                            }}
                          >
                            Save
                          </button>
                        </MDBModalFooter>
                      </MDBModalContent>
                    </MDBModalDialog>
                  </MDBModal>
                </div>
                <div className="ms-4 mt-0">
                  <p className="text-dm margin-fixed">{editPractitioner && editPractitioner?.practiceName}</p>
                  <h6 className="text-al fs-22-18 margin-text-practitioner">Specialty</h6>
                  <p className="text-dm">{editPractitioner && editPractitioner?.specialty}</p>
                  <h6 className="text-al fs-22-18 margin-text-practitioner">Sub-Specialties</h6>
                <p className="text-dm pe-2">{editPractitioner?.subSpecialty && editPractitioner?.subSpecialty.map((item, index, arr) => {
                     return(<div>
                      <p className="m-0">{item}</p>
                     </div>)
                  })}</p>
                  {/* <p className="text-dm pe-2">{editPractitioner?.subSpecialty.map((item, index, arr) => {
                    if (index === arr.length - 1) {
                      return (`${item}`)
                    } else {
                      return (`${item}, `)
                    }
                  })}</p> */}
                  <h6 className="text-al fs-22-18 margin-text-practitioner">Practice Address</h6>
                  <p className="text-dm">{editPractitioner && editPractitioner?.practiceAddress}</p>
                  <h6 className="text-al fs-22-18 margin-text-practitioner">Phone Number</h6>
                  <p className="text-dm">{editPractitioner && editPractitioner?.practicePhoneNumber}</p>
                  <h6 className="text-al fs-22-18 margin-text-practitioner">Education</h6>
                  <p className="text-dm">{profile && profile?.education}</p>
                  <h6 className="text-al fs-22-18 margin-text-practitioner"> Years of Experience</h6>
                  <p className="text-dm">{profile && profile?.yearsOfExperience}</p>

                  <div className="">
                    {(profile?.instagramUrl || profile?.facebookUrl || profile?.linkedinUrl) && <><label className="text-al fs-22-18">Social Media</label>
                      <div className="d-flex">
                        {profile?.instagramUrl && <div className="me-3"><a className="a-link-profile" target='_blank' rel="noreferrer" href={profile?.instagramUrl}><i className="fab fa-instagram ho-icon" /></a></div>}
                        {profile?.facebookUrl && <div className="me-3"><a className="a-link-profile" target='_blank' rel="noreferrer" href={profile?.facebookUrl}><i className="fab fa-facebook-square" /></a></div>}
                        {profile?.linkedinUrl && <div className="me-3"><a className="a-link-profile" target='_blank' rel="noreferrer" href={profile?.linkedinUrl}><i className="fab fa-linkedin" /></a></div>}
                      </div>
                    </>}
                  </div>
                </div>
              </div>
            </div>
          </MDBCol>


          <MDBCol order='' className="second-secction-profile d-flex justify-content-center ">
            <div>
              <div className="bg-profile-input-admin mb-5">
                <div className="d-flex ">
                  <h4 className="mx-3 mb-3 pt-3 ps-4 text-al">About Me</h4>
                  {showbuttons && <p className="count ms-auto me-5 mb-3 pt-3 ps-4 fs-12">count: {300 - secondProfile.aboutMe.length}</p>}
                </div>

                <textarea className="input-profile overflow-auto text-dm" value={secondProfile?.aboutMe} name="aboutMe" maxLength={300} onChange={handleSecondChange} onClick={() => setShowButtons(!showbuttons)}></textarea>
                {showbuttons &&
                  <div className="d-flex bg-purple-modal">

                    <div className="">
                      <button className="square_btn-modal margin-right-button me-2" onClick={() => {
                        setShowButtons(!showbuttons)
                        handleUpdateProfile(secondProfile)
                      }}>Save</button>
                    </div>
                    <div>
                      <button className="square_btn-modal" onClick={() => setShowButtons(!showbuttons)}>Cancel</button>
                    </div>
                  </div>}
              </div>

              <div className="bg-profile-input-admin mb-5">
                <div>
                  <div className="d-flex">
                    <h4 className="m-3 ps-4 text-al">How I Can Help</h4>
                    {showbuttonstwo && <p className="count ms-auto me-5 mb-3 pt-3 ps-4 fs-12">count: {300 - secondProfile?.howCanIHelp?.length}</p>}
                  </div>
                  <textarea className="input-profile overflow-auto text-dm" maxLength={300} value={secondProfile?.howCanIHelp} name="howCanIHelp" onChange={handleSecondChange} onClick={() => setShowButtonsTwo(!showbuttonstwo)}></textarea>
                  {showbuttonstwo &&
                    <div className="d-flex bg-purple-modal">
                      <div>
                        <button
                          className="square_btn-modal margin-right-button me-2"
                          onClick={() => {
                            setShowButtonsTwo(!showbuttonstwo)
                            handleUpdateProfile(secondProfile)
                          }}>Save</button>
                      </div>
                      <div>
                        <button className="square_btn-modal" onClick={() => setShowButtonsTwo(!showbuttonstwo)}>Cancel</button>
                      </div>
                    </div>}
                </div>
              </div>

              <div className="bg-profile-input-admin mb-5">
                <div className="">
                  <div className="d-flex">
                    <h4 className="m-3 ps-4 text-al">Services Offered</h4>
                    {showbuttonsthree && <p className="count ms-auto me-5 mb-3 pt-3 ps-4 fs-12">count: {300 - secondProfile.servicesOffered?.length}</p>}
                  </div>
                  <textarea className="input-profile overflow-auto text-dm" maxLength={300} value={secondProfile?.servicesOffered} name="servicesOffered" onChange={handleSecondChange} onClick={() => setShowButtonsThree(!showbuttonsthree)} ></textarea>
                  {showbuttonsthree &&
                    <div className="d-flex bg-purple-modal">
                      <div>
                        <button
                          className="square_btn-modal margin-right-button me-2"
                          onClick={() => {
                            setShowButtonsThree(!showbuttonsthree)
                            handleUpdateProfile(secondProfile)
                          }}>Save</button>
                      </div>
                      <div>
                        <button className="square_btn-modal" onClick={() => setShowButtonsThree(!showbuttonsthree)}>Cancel</button>
                      </div>
                    </div>}
                </div>

              </div>

              <div className="bg-profile-input-certifications-admin mb-5">
                <div className="icon-plus">
                  <h4 className="m-3 pt-2 ps-4 text-al ">Certifications</h4>
                  <span className="m-3 pt-2 plus-button pe-3" onClick={toggleShowlast}><i className="fas fa-plus"></i></span>
                  <MDBModal show={basicModalLast} setShow={setBasicModalLast} tabIndex='-1' className="">
                    <MDBModalDialog className="boxmodal modal-lg">
                      <MDBModalContent className="bgmodal">
                        <MDBModalHeader>
                          <MDBModalTitle>Edit Certification</MDBModalTitle>
                          <MDBBtn className='btn-close' color='none' onClick={toggleShowlast}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                          <MDBRow className="responsive-grid-modal">

                            <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3">
                              <div>
                                <input type='checkbox' checked={(secondProfile?.certifications && secondProfile?.certifications.includes('Board Certified'))} className="checkbox-squer" name='certifications' value="Board Certified" onChange={handleSecondChange} />
                                <label className="label-responsive">Board Certified</label>
                              </div>
                            </MDBCol>
                            <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3">
                              <div className="margin">
                                <input type='checkbox' checked={(secondProfile?.certifications && secondProfile?.certifications.includes('American Board of Pain Medicine (ABPM)'))} className="checkbox-squer" name='certifications' value='American Board of Pain Medicine (ABPM)' onChange={handleSecondChange} />
                                <label className="label-responsive">American Board of Pain Medicine (ABPM)</label>
                              </div>
                            </MDBCol>
                          </MDBRow>

                          <MDBRow className="responsive-grid-modal">
                            <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3">
                              <div>
                                <input type='checkbox' checked={(secondProfile?.certifications && secondProfile?.certifications.includes('American Board of Physician Specialties (ABPS)'))} className="checkbox-squer" name='certifications' value='American Board of Physician Specialties (ABPS)' onChange={handleSecondChange} />
                                <label className="label-responsive">American Board of Physician Specialties (ABPS)</label>
                              </div>
                            </MDBCol>
                            <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3">
                              <div className="margin">
                                <input type='checkbox' checked={(secondProfile?.certifications && secondProfile?.certifications.includes('American Board of Anesthesiology (ABA)'))} className="checkbox-squer" name='certifications' value='American Board of Anesthesiology (ABA)' onChange={handleSecondChange} />
                                <label className="label-responsive">American Board of Anesthesiology (ABA)</label>
                              </div>
                            </MDBCol>
                          </MDBRow>

                          <MDBRow className="responsive-grid-modal">
                            <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3">
                              <div>
                                <input type='checkbox' checked={(secondProfile?.certifications && secondProfile?.certifications.includes('American Board of Medical Specialties (ABMS)'))} className="checkbox-squer" name='certifications' value='American Board of Medical Specialties (ABMS)' onChange={handleSecondChange} />
                                <label className="label-responsive">American Board of Medical Specialties (ABMS)</label>
                              </div>
                            </MDBCol>
                            <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3">
                              <div className="margin">
                                <input type='checkbox' checked={(secondProfile?.certifications && secondProfile?.certifications.includes('American Board of Family Medicine (ABFM)'))} className="checkbox-squer" name='certifications' value='American Board of Family Medicine (ABFM)' onChange={handleSecondChange} />
                                <label className="label-responsive">American Board of Family Medicine (ABFM)</label>
                              </div>
                            </MDBCol>
                          </MDBRow>

                          <MDBRow className="responsive-grid-modal ">
                            <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3">
                              <div>
                                <input type='checkbox' checked={(secondProfile?.certifications && secondProfile?.certifications.includes('American Board of Obstetrics and Gynecology (ABOG)'))} className="checkbox-squer" name='certifications' value='American Board of Obstetrics and Gynecology (ABOG)' onChange={handleSecondChange} />
                                <label className="label-responsive">American Board of Obstetrics and Gynecology (ABOG)</label>
                              </div>
                            </MDBCol>
                            <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3">
                              <div className="margin">
                                <input type='checkbox' checked={(secondProfile?.certifications && secondProfile?.certifications.includes('American Board of Internal Medicine (ABIM)'))} className="checkbox-squer" name='certifications' value='American Board of Internal Medicine (ABIM)' onChange={handleSecondChange} />
                                <label className="label-responsive">American Board of Internal Medicine (ABIM)</label>
                              </div>
                            </MDBCol>
                          </MDBRow>
                        </MDBModalBody>
                        <MDBModalFooter>
                          <button className="btn main-purple-button blue-hover text-dm"

                            onClick={() => {
                              toggleShowlast()
                              handleUpdateProfile(secondProfile)
                            }}
                          >
                            Save
                          </button>
                        </MDBModalFooter>
                        {/* <button className='buttonmodal mt-4 mb-3 me-4' onClick={() => handleUpdateProfile(secondProfile)}>Save Changes</MDBBtn> */}
                      </MDBModalContent>
                    </MDBModalDialog>
                  </MDBModal>
                </div>
                <div className='px-4 mx-3 pb-3'>
                  {profile?.certifications && profile?.certifications.map((item, index, arr) => {
                    if (index === arr.length - 1) {
                      return (
                        <span className='text-black text-dm'>{item}</span>
                      )
                    } else {
                      return (
                        <span className='text-black text-dm'>{item}, </span>
                      )
                    }
                  })}
                </div>

              </div>
            </div>
          </MDBCol>


          <MDBCol order='' className="d-flex justify-content-center">
            <div className="">
              <div className="availability-admin mb-5">
                <h4 className="mx-3 mb-3 pt-3 text-al ps-4">Availability</h4>
                {editPractitioner?.calendlyUrl ?
                  <Link to={`/calendar/${editPractitioner._id}`}>
                    <div className="position-relative">
                      <img src={calendarIcon} className="calendar-bg" alt="calendar" />
                      <div className="position-absolute top-50 start-50 translate-middle">
                        <button className="button-active blue-hover">Book Now</button>
                      </div>
                    </div>
                  </Link> :
                  <div className="">
                    <div className="position-relative">
                      <img src={calendarIcon} className="calendar-bg" alt='calendar' />
                      <div className="position-absolute top-50 start-50 translate-middle">
                        <button className="button-a blue-hover text-decoration-none border-0 whitespace fs-14-18" onClick={toggleShowCalendly}>SET UP APPOINTMENT BOOKINGS</button>
                        {/* <a href="https://calendly.com/" target="_blank" rel="noreferrer" className="button-a blue-hover text-decoration-none">CALENDLY</a> */}
                      </div>
                    </div>
                    {/* <div className="d-flex px-1">
                      <img src={calendarIcon} className="calendar-icon me-2 ms-2" />
                      <p className="p-0">Set up your booking calendar now through Calendly! (It is not required though). </p>
                    </div>
                    <div className="px-4 py-2">
                      <p className="text-center">After clicking the button, it will take you to Calendly to set up an account, if you don’t have one.</p>
                    </div>
                    <div className="d-flex justify-content-center">
                      <a href="https://calendly.com/" target="_blank" className="button-a blue-hover text-decoration-none">APPOINTMENT BOOKINGS </a>
                    </div> */}
                  </div>
                }
              </div>

              {/* CALENDLY MODAL */}
              <MDBModal show={basicModalCalendly} setShow={setBasicModalCalendly} tabIndex='-1' className="">
                <MDBModalDialog className="boxmodal modal-lg">
                  <MDBModalContent className="bgmodal">
                    <MDBModalHeader>
                      <MDBModalTitle>Appointment Booking Instructions</MDBModalTitle>
                      <MDBBtn className='btn-close' color='none' onClick={toggleShowCalendly}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <ol>
                        <li className="p-2 text-dm">1. Set up your booking calendar now through Calendly!</li>
                        <li className="p-2 text-dm">2. After clicking the button, it will take you to Calendly to set up an account, if you don’t have one.</li>
                        <li className="p-2 text-dm">3. Finally, add the ending of your Calendly url to your account to start accepting bookings!</li>
                      </ol>
                    </MDBModalBody>
                    <MDBModalFooter>
                      <button className="btn btn-secondary text-dm" onClick={toggleShowCalendly}>
                        Close
                      </button>
                      <a href="https://calendly.com/" target="_blank" rel="noreferrer" className="btn main-purple-button blue-hover text-dm">Setup Booking Calendar</a>
                    </MDBModalFooter>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>

              <div className="policy-admin mb-5">
                {/* <div className="d-flex"> */}
                <h4 className="mx-3 mt-3 pt-3 ps-4 text-al">Cancellation Policy</h4>
                {showbuttonsfour && <p className="count ms-3 ps-4 fs-12 mb-1">count: {300 - secondProfile.cancellationPolicy?.length}</p>}
                {/* </div> */}
                <textarea className="input-policy overflow-auto" maxLength={300} value={secondProfile?.cancellationPolicy} name="cancellationPolicy" onChange={handleSecondChange} onClick={() => setShowButtonsFour(!showbuttonsfour)} ></textarea>
                {showbuttonsfour &&
                  <div className="d-flex bg-purple-modal">

                    <div className="">
                      <button className="square_btn-modal margin-right-button me-2" onClick={() => {
                        setShowButtonsFour(!showbuttonsfour)
                        handleUpdateProfile(secondProfile)
                      }}>Save</button>
                    </div>
                    <div>
                      <button className="square_btn-modal" onClick={() => setShowButtonsFour(!showbuttonsfour)}>Cancel</button>
                    </div>
                  </div>}
              </div>

              <div className="certification-admin mt-3 pb-5 mb-4">
                <div>
                  <div className='d-flex'>
                    <h4 className="mx-3 my-2 pt-2 whitespace text-al payment ps-4">Payment Methods</h4>
                    <span className="mx-3 my-2 pt-2 plus-button payment-icon negative-margin-cross"><i className="fas fa-plus" onClick={toggleShowpayment}></i></span>
                  </div>
                  <div className="d-flex ms-2">
                    {secondProfile.paymentMethods && secondProfile.paymentMethods.map((item) => {
                      if (item === "American Express") {
                        return (
                          <img className="credit-card-icon ms-2" src={AMEX} alt="amex" />
                        )
                      }
                      if (item === "Discover") {
                        return (
                          <img className="credit-card-icon ms-2" src={DISCOVER} alt="discover" />
                        )
                      }
                      if (item === "Mastercard") {
                        return (
                          <img className="credit-card-icon ms-2" src={MASTERCARD} alt="mastercard" />
                        )
                      }
                      if (item === "Visa") {
                        return (
                          <img className="credit-card-icon ms-2" src={VISA} alt="visa" />
                        )
                      }
                    })}
                  </div>
                </div>
              </div>
              <MDBModal show={basicModalpayment} setShow={setBasicModalpayment} tabIndex='-1'>
                <MDBModalDialog className="boxmodal modal-md">
                  <MDBModalContent className="bgmodal">
                    <MDBModalHeader>
                      <MDBModalTitle>Accepted Payment Methods</MDBModalTitle>
                      <MDBBtn className='btn-close' color='none' onClick={toggleShowpayment}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <h1 className="text-center text-dm">COMING SOON!</h1>
                      {/* <div className="d-flex p-2 align-items-center">
                        <input type='checkbox' className="checkbox-squer" checked={(secondProfile?.paymentMethods && secondProfile?.paymentMethods.includes('American Express'))} name='paymentMethods' value='American Express' onChange={handleSecondChange} />
                        <img className="credit-card-icon ms-2" src={AMEX} alt="amex" />
                        <label className="label-responsive text-dm">American Express</label>
                      </div>
                      <div className="d-flex p-2 align-items-center">
                        <input type='checkbox' className="checkbox-squer" checked={(secondProfile?.paymentMethods && secondProfile?.paymentMethods.includes('Discover'))} name='paymentMethods' value='Discover' onChange={handleSecondChange} />
                        <img className="credit-card-icon ms-2" src={DISCOVER} alt="discover" />
                        <label className="label-responsive text-dm">Discover</label>
                      </div>
                      <div className="d-flex p-2 align-items-center">
                        <input type='checkbox' className="checkbox-squer" checked={(secondProfile?.paymentMethods && secondProfile?.paymentMethods.includes('Mastercard'))} name='paymentMethods' value='Mastercard' onChange={handleSecondChange} />
                        <img className="credit-card-icon ms-2" src={MASTERCARD} alt="mastercard" />
                        <label className="label-responsive text-dm">Mastercard</label>
                      </div>
                      <div className="d-flex p-2 align-items-center">
                        <input type='checkbox' className="checkbox-squer" checked={(secondProfile?.paymentMethods && secondProfile?.paymentMethods.includes('Visa'))} name='paymentMethods' value='Visa' onChange={handleSecondChange} />
                        <img className="credit-card-icon ms-2" src={VISA} alt="visa" />
                        <label className="label-responsive text-dm">Visa</label>
                      </div> */}

                      {/* <MDBRow className="responsive-grid-modal ">
                          <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3 margin-left">
                            <div>
                              <input type='checkbox' className="checkbox-squer" name='certifications' value='American Board of Obstetrics and Gynecology (ABOG)' onChange={handleSecondChange} />
                              <label className="label-responsive">MasterCard</label>
                            </div>
                          </MDBCol>
                          <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3">
                            <div className="margin">
                              <input type='checkbox' className="checkbox-squer" name='certifications' value='American Board of Internal Medicine (ABIM)' onChange={handleSecondChange} />
                              <label className="label-responsive">Visa</label>
                            </div>
                          </MDBCol>
                        </MDBRow>
                        <MDBRow className="responsive-grid-modal ">
                          <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3 margin-left">
                            <div>
                              <input type='checkbox' className="checkbox-squer" name='certifications' value='American Board of Obstetrics and Gynecology (ABOG)' onChange={handleSecondChange} />
                              <label className="label-responsive">American Express</label>
                            </div>
                          </MDBCol>
                          <MDBCol size='4' className="whitespace d-flex justify-content-start mb-3">
                            <div className="margin">
                              <input type='checkbox' className="checkbox-squer" name='certifications' value='American Board of Internal Medicine (ABIM)' onChange={handleSecondChange} />
                              <label className="label-responsive">Discover</label>
                            </div>
                          </MDBCol>
                        </MDBRow> */}
                    </MDBModalBody>

                    {/* <MDBModalFooter>

                      <button className="btn btn-secondary text-dm" onClick={toggleShowpayment}>
                        Close
                      </button>
                      <button className="btn main-purple-button blue-hover text-dm" onClick={() => {
                        toggleShowpayment()
                        handleUpdateProfile(secondProfile)
                      }}>Save</button>

                    </MDBModalFooter> */}
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>

            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <NewFooter />
    </div >
    </div>
  )
}
export default AdminEditPractitioners

